"use client";
import { PartnersSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";

const Partners: FC<PartnersSectionProps> = () => {
  return (
    <h3
      style={{
        backgroundColor: "black",
        color: "white",
        textAlign: "center",
        padding: 50,
      }}
    >
      Partners
    </h3>
  );
};

export default Partners;
